<template>
  <event-series-preview>
    <template slot="header">
      <h5 v-if="clusterType != null && !showLessons">
        {{ trans_choice('subscription.eventseries.eventseries',2) }}
      </h5>
      <h5 v-else-if="numberOfCourses !== 0">
        {{ trans('courses.number_of_lessons') }}: {{ numberOfEvents }}
      </h5>
      <h5 v-else>
        {{ trans('series.preview') }}
      </h5>
    </template>

    <template slot="explanationAllowShopping">
      <p
        v-if="clusterType != null"
        class="col-xs-12"
      >
        {{ trans_choice('subscription.eventseries.explanation_series', Object.keys(eventClusters).length,
                        { number: Object.keys(eventClusters).length,
                          type: trans('core.' + clusterType) }) }}
      </p>
    </template>
  </event-series-preview>
</template>

<script>
import EventSeriesPreview from '../EventSeriesPreview/EventSeriesPreview.vue'

export default {

  name: 'EventSerieSubscribablesPreview',
  components: { EventSeriesPreview },

  computed: {

    showLessons () {
      return this.$store.state.steps.active_step[0].step.lessonSelector === true
    },

    clusterType () {
      return this.$store.state.eventSerieSubscribables.cluster_type
    },

    eventClusters () {
      return this.$store.state.eventSeries.event_clusters
    },

    numberOfCourses () {
      return Object.keys(this.$store.state.eventSeries.courses).length
    },

    numberOfEvents () {
      let courses = this.$store.state.eventSeries.course_event_ids
      let number = 0
      Object.values(courses).forEach(course => {
        number = number + course.length
      })
      return number
    },
  },
}
</script>

<style>
</style>
